<form class="popupForm" style="min-height: 200px;" [formGroup]="componentForm">

  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{ 'group_link' | GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="state==='default'">
      <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 200px;">
        <div class="field-bigger-info-message">
          {{'share_group_link_message' | GetLabelPipe}}
        </div>
        <div class="copy-wrapper" fxLayout="row">
          <input type="text" formControlName="shareInput" readonly>
          <div class="icon-wrapper icon-wrapper-right" (click)="copyLink()">
            <mat-icon color="accent">content_copy</mat-icon>
          </div>
        </div>
      </mat-dialog-content>
      <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="10px">
        <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
          {{'close'|GetLabelPipe}}
        </button>
        <button type="submit" class="widerButton font16" mat-raised-button
                color="accent" (click)="copyLink()">
          {{'copy'|GetLabelPipe}}
        </button>
      </div>
    </ng-container>
  </div>

</form>
